import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@hooks/useStore';
import {
  selectFilesRequestParams,
  setIsFinishAccountSignUpModalState,
  setIsUpload
} from '@state/files/filesSlice';
import { PRIVATE, Statuses } from '@helpers';
import { FileAccessType } from '@features/files/types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { selectUserState } from '@state/user/userSlice';

export const useIsDisabledUploadButton = (): boolean => {
  const location = useLocation();
  const { accessType }: { accessType: FileAccessType[] } = useAppSelector(selectFilesRequestParams);

  return location.pathname === '/home/trash' || !accessType.includes(PRIVATE);
};

export const useOnClickUpload = () => {
  const dispatch = useDispatch();
  const user = useAppSelector(selectUserState);

  return (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (user.state === Statuses.Invited) {
      dispatch(setIsFinishAccountSignUpModalState(true));
    } else {
      dispatch(setIsUpload({ id: performance.now(), mode: undefined }));
    }
  };
};
